import Tracking from './Tracking'
import { identify } from './identify'
import { track } from './track'
import { time } from './time'

export default Tracking
export { identify, track, time }
